// usePushNotifications.ts
import { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Device } from '@capacitor/device';
import { API, getDataCookie } from 'common';
import { useAppDispatch } from 'store/hooks';
import notificationActions from 'store/notification/actions';
import { PAGE_SIZE_DEFAULT } from '../components/NotificationButton';
import { useHistory } from 'react-router-dom';
import { toastRef } from 'components/Toast';
import { notificationRef } from 'components/Modal/NotificationModal';

export default function usePushNotifications() {

  const dispatch = useAppDispatch();
  const _history = useHistory();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const setup = async () => {
      // Request permission
      const permission = await PushNotifications.requestPermissions();
      if (permission.receive !== 'granted') return;

      // Register with FCM/APNs
      await PushNotifications.register();
      console.log(Capacitor.isNativePlatform());
      console.log(Capacitor.getPlatform());
      console.log('ooo jjjjjj');

    };

    // Get the device token — send this to your backend
    const tokenListener = PushNotifications.addListener(
      'registration',
      async (token) => {
        console.log('tokennnnn');

        console.log('token', token);

        // REACT_APP_COOKIE_KEY is always defined at build time (mirrors common.ts's own usage of `!` on env keys).
        const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY!);
        const platform = Capacitor.getPlatform() === 'ios' ? 'IOS' : 'ANDROID';
        const idInfo = await Device.getId();
        try {
            const response = await API.post('staff-notification/register-token', {
              payload: {
                deviceId: idInfo.identifier,
                fcmToken: token.value,
                platform: platform,
                staffId: staffId
              }
            });

            if (response.status == 200) {
              console.log('Register FCM Token success');
            }

          } catch (error) {
            console.error('AssignTo Submit', error);
          }
        // TODO: send token.value to your server
      }
    );

    // Handle notification received while app is open
    const receivedListener = PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification) => {
        console.log('noti received');
        console.log('noti received');
        console.log('noti received');
        console.log('noti received');

        const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY!);
        dispatch(notificationActions.getNotifications.fetch({
          page: 0,
          size: PAGE_SIZE_DEFAULT,
          staffId: staffId
        }));
        dispatch(notificationActions.countNotificationUnread.fetch({staffId: staffId}));

        // Show alert when app is active
        const title = notification.title || 'Notification';
        const body = notification.body || 'You have a new notification';
        toastRef.current?.show(body);
        notificationRef.current?.open({ title, body });

        await LocalNotifications.schedule({
          notifications: [
          {
            title: notification.title || 'No title',
            body: notification.body || 'No body',
            // smallIcon isn't part of Capacitor's PushNotificationSchema type but is read from
            // the raw payload at runtime (Android sends it) — cast preserves that dynamic access.
            smallIcon: (notification as any)?.smallIcon,
            id: new Date().getTime(),
          },
				],
			});
      }
    );

    // Handle tap on notification (app in background/closed)
    const actionListener = PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (action) => {
        console.log('Notification tapped:', action);
        const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY!);
        const notificationId = action.notification?.data?.notificationId;
        if (!notificationId) return;
        console.log(action?.notification?.data?.appointmentId);

        if (action?.notification?.data?.appointmentId) {
          _history.push(`/appointment-staff/${action.notification.data.appointmentId}`);
        }
        try {
          const response = await API.put(`staff-notification/${notificationId}/read?staffId=${staffId}`);

          if (response.status == 200) {
            dispatch(notificationActions.getNotifications.fetch({
              page: 0,
              size: PAGE_SIZE_DEFAULT,
              staffId: staffId
            }));
            console.log('Mark as read success');
          }
        }

        catch (error) {
          console.error('Mark as read error', error);
        }
      }
    );

    PushNotifications.addListener('registrationError', err => {
      console.error('Registration error:', err);
    });

    setup();

    return () => {
      tokenListener.then(l => l.remove());
      receivedListener.then(l => l.remove());
      actionListener.then(l => l.remove());
    };
  }, []);
}
